/* Global styling for main content (ship page, fleet page etc) */

export const horizontalGutter = { lg: 24, md: 16, sm: 16, xs: 8 }
export const verticalGutter = { lg: 24, md: 16, sm: 16, xs: 16 }

export const screenSizeMedium = 768
